import React from 'react';
import logoUrl from '../assets/logo.png';

type LogoVariant = 'color' | 'navy' | 'white';

interface NHCLogoProps {
  /** Preferred sizing prop. */
  size?: number;
  /** Alias for size kept for existing call sites. */
  w?: number;
  color?: string;
  variant?: LogoVariant;
}

export default function NHCLogo({ size = 24, w, color, variant }: NHCLogoProps) {
  const resolvedSize = w ?? size;
  // Note: variant and color are ignored since we are using a static PNG logo now.
  return (
    <img 
      src={logoUrl} 
      alt="NeoHealthCard Logo" 
      style={{
        width: resolvedSize,
        height: resolvedSize,
        objectFit: 'contain',
        flexShrink: 0
      }} 
    />
  );
}
